import React, { useEffect, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import objectPath from 'object-path'
import Divider from '@material-ui/core/Divider'
import Paper from '@material-ui/core/Paper'

import BusinessDetails from 'components/book/BusinessDetails'

import bookSelectors from 'store/selectors/booking'
import bookActions from 'store/modules/booking'
import snackbarActions from 'store/modules/snackbar'
import routerActions from 'store/modules/router'
import SummaryWrapper from './SummaryWrapper'
import constants from 'shared/src/constants'
import Template from 'shared/src/template'

const useStyles = makeStyles(theme => ({
  root: {
    
  },
  payButton: {
    margin: theme.spacing(2),
  },
  panel: {
    textAlign: 'left',
  },
  loading: {
    width: '400px',
  },
  section: {
    marginTop: theme.spacing(2),
  },
  businessDetails: {
    width: '400px',
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
  },
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  }
}))

const BookingFormConfirmation = ({
  
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  
  const slot = useSelector(bookSelectors.slot)
  const config = useSelector(bookSelectors.slotFormConfig)
  const options = useSelector(bookSelectors.options)
  const reservation = useSelector(bookSelectors.reservation)
  const reservationPaymentStatus = useSelector(bookSelectors.reservationPaymentStatus)

  const template = useMemo(() => {
    return Template({
      slot,
      config,
      options,
    })
  }, [
    slot,
    config,
    options,
  ])

  const data = useMemo(() => {
    return {
      title: template(objectPath.get(config, 'payment.confirmed_title', 'Your booking is confirmed!')),
      notes: objectPath.get(config, 'payment.confirmed_notes', []).map(note => template(note)),
    }
  }, [
    template,
    config,
  ])

  // this will loop because the "reservation" object changes each time
  useEffect(() => {
    if(!reservation) {
      dispatch(routerActions.navigateTo('home'))
      return
    }
    if(reservation.status == constants.BOOKING_STATUS_CONFIRMED) {
      dispatch(bookActions.setReservedBookingToken(''))
      dispatch(bookActions.setStripeBookingToken(''))
      dispatch(snackbarActions.setSuccess('Your booking has been confirmed'))
    }
    else {
      setTimeout(() => {
        dispatch(bookActions.reloadReservedBooking())
      }, 1000)
    }
  }, [
    reservation,
  ])

  if(!reservation) return null

  return (
    <SummaryWrapper
      withStoreOptions
      withForward={ false }
      withBack={ false }
    >
      <div className={ classes.root }>
        {
          reservationPaymentStatus == 'confirmed' ? (
            <>
              <Typography gutterBottom variant="h6">{ data.title }</Typography>
              <Typography gutterBottom variant="caption">Your booking reference:</Typography>
              <Typography gutterBottom variant="h4" color="primary">{ reservation.reference }</Typography>
              {
                data.notes.map((note, i) => (
                  <Typography key={ i } gutterBottom variant="body1">{ note }</Typography>
                ))
              }
              <Divider className={ classes.divider } />
              <Typography gutterBottom variant="body1">In the meantime, if you have any questions, you can get in touch:</Typography>
              <Paper className={ classes.businessDetails }>
                <BusinessDetails
                  slotConfig={ config }
                />
              </Paper>
            </>
          ) : (
            <Typography gutterBottom variant="h6">Confirming Payment</Typography>
          )
        }
        <div className={ classes.section }>
          <Button
            color="primary"
            variant="outlined"
            onClick={() => {
              dispatch(routerActions.navigateTo('book.form.calendar', {
                project: reservation.project,
                bookingform: reservation.bookingform,
                date: 'today',
              }))
              setTimeout(() => {
                location.reload()
              }, 100)
            }}
          >
            Back to Calendar
          </Button>
        </div>
      </div>
    </SummaryWrapper>
  )
}

export default BookingFormConfirmation